import { render, staticRenderFns } from "./RoomsModal.vue?vue&type=template&id=cddad68e&"
import script from "./RoomsModal.vue?vue&type=script&lang=js&"
export * from "./RoomsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports